import { useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import studentsAPI from "../../../services/students";
import { TabPanel, TabView } from "primereact/tabview";
import StudentDetailHeader from "./components/StudentDetailHeader";
import StudentDetailComponent from "./components/StudentDetailComponent";
import StudentRegistrationFormComponent from "../../registrations/candidates/components/StudentRegistrationFormComponent";
import { PERMISSION_TRAINING_REGISTRATION } from "../../../permissions";
import { useAuthContext } from "../../../hooks/useAuthContext";
import RegistrationStepsComponent from "../../registrations/candidates/components/RegistrationStepsComponent";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import StudentUpdatesHistoryListComponent from "./components/StudentUpdatesHistoryListComponent";


const StudentDetailPage = () => {
  const { hasPermission, currentMembership } = useAuthContext();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const studentId = params.studentId;
  //
  const studentQuery = studentsAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    studentId
  );
  const studentObj = studentQuery?.data?.data;
  //
  const hasGetRegistrationPermission = hasPermission(PERMISSION_TRAINING_REGISTRATION.GET)
  const canViewUpdatesHistory = currentMembership?.is_admin || currentMembership?.is_owner;
  // states

  return (
    <>
      <MeaPage
        query={studentQuery}
        showBackButton={false}
        header={<StudentDetailHeader student={studentObj} schoolId={schoolId} trainingId={trainingId} callback={() => {
          studentQuery?.refetch()
        }} />}
      >
        <div className="mt-0">
          <TabView activeIndex={0}>
            <TabPanel header="Ficher élève" leftIcon="pi pi-user mr-2" className="mr-2">
              <StudentDetailComponent student={studentObj} schoolId={schoolId} trainingId={trainingId} callback={() => {
                studentQuery?.refetch()
              }} />
            </TabPanel>
            {hasGetRegistrationPermission && (
              <TabPanel header="Dossier d'inscription" leftIcon="pi pi-book mr-2" className="mr-2">
                <div className="m-0">
                  <RegistrationStepsComponent student={studentObj}
                    schoolId={schoolId}
                    trainingId={trainingId}
                    callback={() => {
                      studentQuery?.refetch()
                    }} />
                  <StudentRegistrationFormComponent
                    student={studentObj}
                    schoolId={schoolId}
                    trainingId={trainingId}
                    callback={() => {
                      studentQuery?.refetch()
                    }}
                  />
                </div>
              </TabPanel>
            )}
            {canViewUpdatesHistory && (
              <TabPanel header="Historique des modifications" leftIcon="pi pi-pencil mr-2" className="ml-2">
                <MeaLoadingContent objectQuery={studentQuery}>
                  <StudentUpdatesHistoryListComponent student={studentObj} schoolId={schoolId} trainingId={trainingId} />
                </MeaLoadingContent>
              </TabPanel>
            )}
          </TabView>
        </div>
      </MeaPage>
    </>
  );
};
export default StudentDetailPage;
